import { useAuth } from '../lib/auth'
import { userClaimIds } from '../utils/userClaims'

export function useOtherCustomerIds(): string[] | undefined {
  const { user } = useAuth()
  return user ? user[userClaimIds.previousNetSuiteIds] || [] : undefined
}

export default useOtherCustomerIds
